const OVERLAY_COLOR = 'rgba(111, 151, 223, 150)';

module.exports = {
    OVERLAY_COLOR
};
